import { FC, useRef, useState } from "react"
import imageEmail from '../../../assets/images/emailImage.png'
import './validate.css'

import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { cpfCnpjNoMask } from "../../../functions/mask";
import { Loading } from "../../../components/Loading";
import useAuth from "../../../hooks/useAuth";
import { parseJwt } from "../../../functions/util";
import { DecodedTokenData } from "../../../contexts/authContext";
 

const ValidateAccount: FC = () => {

    const [code, setCode] = useState(['', '', '', '']); // Array para armazenar cada dígito
    const inputRefs = useRef<any>([]);
    const navigate = useNavigate()
    const { pluginspace_id } = useParams();
    const { getToken } = usePluginspace();
    const [loading, setLoading] = useState(false);
    const { setToken, setPluginspaceData } = usePluginspace()
    const { setLoginInfo } = useAuth()


    const handleChange = (e: any, index: number) => {
        const { value } = e.target;
        if (/^\d$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (index < 3) {
                inputRefs.current[index + 1].focus();
            }
        } else if (value === '' && index > -1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            inputRefs.current[index === 0 ? index : index - 1].focus();
        }
    };


    const validar = async () => {
        setLoading(true)
        const ppLS = JSON.parse(localStorage.getItem('payload')!)
        const payload = {
            email: ppLS.email,
            doc: cpfCnpjNoMask(ppLS.doc),
            validationCode: code.join('')
        }
        await api
            .post(
                `/api/customer/validCodeCustomer`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response: any) => {
                setLoading(false)
                const data = response.data
                if (!data || !data.success) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro na validação do código,tente novamente!',
                    })
                    return
                }

                if (process.env.REACT_APP_JWT_SALT && data.pemission.accessToken) {
                    const token = data.pemission.accessToken;
                    localStorage.setItem('loginInfo', JSON.stringify(token))
                    const tkNoSalt = token.split(process.env.REACT_APP_JWT_SALT).join('')
                    const tk: DecodedTokenData | null = parseJwt(tkNoSalt)

                    if (tk) {
                        setLoginInfo({
                            accessToken: token.accessToken,
                            expiratedAt: token.expiratedAt,
                            identifier: tk.identifier,
                            email: tk.email,
                            plugintype: tk.plugintype,
                            pluginspaceId: tk.pluginspaceId,
                            plugintypeId: tk.plugintypeId,
                            profile: tk.profile,
                        })

                        setPluginspaceData(tk?.pluginspaceId)
                        setToken(token);
                        navigate(`/${pluginspace_id}/register/success`)
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro na validação do código,tente novamente!',
                    })
                }

            })
            .catch((err: any) => {
                setLoading(false)
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro na validação do código,tente novamente!',
                })

                console.log(err);
            });
    }

    async function resendEmail() {
        setLoading(true)
        const ppLS = JSON.parse(localStorage.getItem('payload')!)
        const payload = {
            email: ppLS.email,
            doc: cpfCnpjNoMask(ppLS.doc),
        }

        await api
            .post(
                `/api/customer/resend/validCodeCustomer`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then(async (response: any) => {
                setLoading(false)
                const data = response.data

                if (!data || !data.success) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro no reenvio do codigo!',
                    })
                    return
                } else {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: 'Codigo reenviado com sucesso!',
                    })
                }



            })
            .catch((err: any) => {
                setLoading(false)
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro no reenvio do codigo!',
                })

                console.log(err);
            });
    }



    return (
        <>{
            loading ?
                (
                    <div style={{
                        width: '100%',
                        height: 'calc(100vh)',
                        zIndex: "100",
                        position: "absolute",
                        left: '0',
                        top: "0"
                    }}>
                        <Loading
                            type="spinningBubbles"
                            color="#FFF"
                            width={64}
                            height={64}
                        />
                    </div>
                ) : (
                    <>
                        <div className="validateContent">
                            <div className="validateImage">
                                <img src={imageEmail} alt="Logo" />
                            </div >


                            <div className="validateText">
                                <h3>Validação de email</h3>
                            </div>
                            <div>
                                <span>Enviamos uma mensagem para o seu email com um código de 4 digitos.</span>
                            </div>
                            {/* Fazer os campos de confirmação de codigo */}
                            <div className="confimCode">
                                {code.map((digit, index) => (
                                    <div className="digit-input">
                                        <input
                                            key={`${index}-${digit}`}
                                            type="text"
                                            className="classInput"
                                            value={digit}
                                            onChange={(e) => handleChange(e, index)}
                                            //onKeyDown={(e) => handleKeyDown(e, index)}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className="msgSendAgain">
                                <span>Não recebeu a mensagem?</span>
                                <a onClick={() => resendEmail()}>Clique aqui para enviar novamente</a>
                            </div>


                            <div className="buttonValidate">
                                <button
                                    onClick={() => validar()}
                                >Validar</button>
                            </div>


                            {/*
                            
                            <div className="msgProblem">
                                <span>Problema para receber a mensagem?</span>
                                <a>Clique aqui para utilizar outro email</a>
                            </div>
                            */
                            }
                        </div >
                    </>
                )

        }
        </>
    )
}

export { ValidateAccount }